// Some common functions used both in Mini & Normal upload UI
const backValidationUrl = "/api/validation";
const backJSONUrl = "/api/fileset";

export const sleep = (time) =>
    new Promise((resolve) => setTimeout(resolve, time));

export function completeUpload(tokenString) {
    try {
        const payload = {
            status: "done",
        };

        const headers = {
            "Content-Type": "application/json",
            Authorization: `${tokenString}`,
        };

        const options = {
            method: "POST",
            headers,
            body: JSON.stringify(payload),
        };

        fetch(backJSONUrl, options);
    } catch (err) {
        return { errorlog: err };
    }
}

export async function getPostUrl(filePath, tokenString) {
    try {
        const payload = {
            path: filePath,
            status: "validation",
        };

        const headers = {
            "Content-Type": "application/json",
            Authorization: `${tokenString}`,
        };

        const options = {
            method: "POST",
            headers,
            body: JSON.stringify(payload),
        };

        // const response = await fetch(backValidationUrl, options);
        // return await response.json();

        const maxRetries = 18;
        let attempt = 0;

        while (attempt < maxRetries) {
            const response = await fetch(backValidationUrl, options);
            if (response.ok) {
                return await response.json();
            } else if (response.status >= 500 && response.status < 600) {
                console.log(`Attempt ${attempt + 1} failed with status: ${response.status}`);
            } else {
                return { error: `Request failed with status: ${response.status}` };
            }
            attempt++;
            if (attempt < maxRetries) {
                await sleep(10000);
                console.log("Sleeping for 10 seconds before retrying...");
            }
        }
    } catch (err) {
        return { errorlog: err };
    }
}

export async function validatePostUrl(payload) {
    let result = {
        isOk: true,
        data: payload.hasOwnProperty("description") ? payload.description : "No information from the server",
        code: 200,
    };

    if (payload.hasOwnProperty("status") && payload.hasOwnProperty("signed_url")) {
        switch (payload.status) {
            case "success":
                break;
            default: {
                result.isOk = false;
                result.data = "Can not get upload url";
                result.code = 2001;
                return result;
            }
        }

        if (!(payload.signed_url.hasOwnProperty("url") && payload.signed_url.hasOwnProperty("fields"))) {
            result.isOk = false;
            result.code = 2002;
            result.data = payload.hasOwnProperty("description")
                ? payload.description
                : "Can not get upload url. No information from the server";
            return result;
        }
    } else {
        result.isOk = false;
        result.data = "Can not get upload url";
        result.code = 2000;
        return result;
    }
    return result;
}

export async function generatePath(fpath, fname) {
    let fileIndex = fpath.lastIndexOf("/");
    let newPath = fpath.substring(0, fileIndex + 1) + fname;

    return newPath;
}

export async function upload2S3Post(presignedData, file) {
    try {
        const formData = new FormData();
        Object.keys(presignedData.fields).forEach((key) => {
            formData.append(key, presignedData.fields[key]);
        });
        formData.append("file", file);

        const options = {
            method: "POST",
            body: formData,
        };

        // const response = await fetch(presignedData.url, options);
        // const respOk = response.status >= 200 && response.status < 300;

        const maxRetries = 10;
        let attempt = 0;

        while (attempt < maxRetries) {
            const response = await fetch(presignedData.url, options);
            const respOk = response.status >= 200 && response.status < 300;

            if (respOk) {
                return {
                    ok: true,
                    data: null,
                };
            }

            attempt++;
            if (attempt < maxRetries) {
                console.log(`Attempt ${attempt} failed with status: ${response.status}`);
                await sleep(5000); // Wait 5 seconds before retrying
            }
        }

        return {
            ok: false,
            data: "Something went wrong with the upload, please try to reupload this file",
        };
    } catch (err) {
        return {
            ok: false,
            data: "Something went wrong with the upload, please try to reupload this file",
        };
    }
}
